import * as React from "react";
import { ContextStore } from "../../../../../../react-core/Flux/Variables";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";
import { getEnumValues } from "../../../../../../react-core/Utils/Enum";
import { CustomerType } from "../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { Organisation } from "../../../../../../Wrap/Models/Models/Customer/Organisation";
import { User } from "../../../../../../Wrap/Models/Models/User/User";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { Permission } from "../../../../../Shared/Permission/Permission";
import { UserStore } from "../../../../Stroes/Variable";
import { Urls } from "../../../../Urls";
import { ClientRecordAction } from "../../ClientRecord/Action/ClientRecordAction";
import { ClientRecordTab } from "../../ClientRecord/Resource/Contents";
import { ClientRecordStore } from "../../ClientRecord/Store/Variable";
import { PortfolioDashboardAction } from "../Action/PortfolioDashboardAction";
import {
    consolidatedAccountDashboardTabEnum,
    dashboardRelatedPageEnum,
    portfolioDashboardTabEnum,
    prospectDashboardTabEnum,
} from "../Resource/Content";
import { PortfolioDashboardActivity } from "./Activity/Activity";
import { PortfolioDashboardHeader } from "./Common/PortfolioDashboardHeader";
import { isConsolidate, isTradingAccount } from "./Common/PortfolioDashboardHelper";
import { PortfolioDashboardDocuments } from "./Document/Documents";
import { PortfolioDashboardInsights } from "./Insights/Insights";
import { PortfolioDashboardInvestment } from "./Investment/Investment";
import { PortfolioDashboardPerformance } from "./Performance/Performance";
import { PortfolioDashboardRoles } from "./Role/Roles";
import { PortfolioDashboardSummary } from "./Summary/Summary";
import { PortfolioDashboardTransactions } from "./Transactions/Transactions";
import { ContextType } from "../../../../../../Wrap/Constants/Enums/ContextType";
import { ClientReport } from "./ClientReport/ClientReport";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { Action } from "../../../../Actions/Action";
import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { ProductOverview } from "./ProductOverview/Component/ProductOverView";
import { RestrictionReason } from "../../../../../../Wrap/Models/Models/Account/Restrictions/RestrictionReason";
import { RestrictionReasonAction } from "../Action/RestrictionReasonAction";
import { RestrictionReasonStore } from "../Store/Variables";
import { PresentationViewWrapper } from "./Common/PresentationViewWrapper";
import { CoachMarkerContext } from "../../../../../Shared/CoachMarkers/CoachMarkerContext";
import { getSummaryCoachmarkerConfig } from "./Summary/Resource/content";
import { investmentCoachmarkerConfig } from "./Investment/Resource/Content";
import { performanceCoachmarkerConfig } from "./Performance/Resource/Content";
import { rolesCoachmarkerConfig } from "./Role/Resource/Content";
import { Lightbox, LightboxType } from "../../../../../../react-core/Html/Components/Lightbox";
import { VulnerabilityDetail } from "../../../../../../Wrap/Models/Models/Customer/VulnerabilityDetail";
import { CookieHelper } from "../../../../../../react-core/Helpers/CookieHelper";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { NoteType } from "../../../../../../Wrap/Constants/Enums/Customer/NoteType";
import { NoteDetailModel } from "../../../../../../Wrap/Models/Models/Customer/NoteDetailModel";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { PermissionAction } from "../../../../../Shared/Permission/Action/PermissionAction";
import { PortfolioDashboardStore } from "../Store/Variable";
import { AccountStatus } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { TitleMap } from "../../../../../Shared/Entities/Maps/TitleMap";
import { EsgAnalyser } from "./EsgAnalyzer/EsgAnalyser";

interface IPortfolioDashboardProps extends React.Props<PortfolioDashboard> {}

interface IPortfolioDashboardState {
    data?: any;
    tabIndex:
        | portfolioDashboardTabEnum
        | dashboardRelatedPageEnum
        | prospectDashboardTabEnum
        | consolidatedAccountDashboardTabEnum;
    userInfo: User;
    isLoading: boolean;
    isProspect: boolean;
    isConsolidatedAccount: boolean;
    customerType: CustomerType;
    name: string;
    accountId: string;
    restrictionReasons: RestrictionReason[];
    showVulnerabilityPopUp: boolean;
    vulnerabilityDetail: VulnerabilityDetail[];
    isPresentationView: boolean;
    importantNotes: NoteDetailModel[];
    hasReadWriteAccessToAdviser: boolean;
    isPresentationClicked: boolean[];
}

export class PortfolioDashboard extends BaseComponent<IPortfolioDashboardProps, IPortfolioDashboardState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            tabIndex: null,
            userInfo: UserStore.getUserInfo(),
            isLoading: true,
            isProspect: false,
            isConsolidatedAccount: false,
            customerType: null,
            name: "",
            accountId: "",
            restrictionReasons: [],
            showVulnerabilityPopUp: false,
            vulnerabilityDetail: null,
            isPresentationView: null,
            importantNotes: [],
            hasReadWriteAccessToAdviser: true,
            isPresentationClicked: Array(Object.keys(portfolioDashboardTabEnum).length).fill(false),
        };
        this.subscribeToStore(ClientRecordStore, () => this.onClientRecordStoreChange());
        this.subscribeToStore(RestrictionReasonStore, () => this.onRestrictionReasonStoreChange());
        this.setState = this.setState.bind(this);
        this.onPresentationStatusChange = this.onPresentationStatusChange.bind(this);
    }

    public componentWillMount() {
        this.getMultiSelection();
        const { entityId, hierarchyLevel } = this.getCusomterEntityId();
        if (hierarchyLevel == HierarchyLevelName.Customer) {
            ClientRecordAction.getPersonalDetail(entityId.toString());
            ClientRecordAction.getOrganisationDetail(entityId.toString());
            ClientRecordAction.getCompanyDetail(entityId.toString());
            RestrictionReasonAction.getAccountRestrictions(entityId);
            const settings = CookieHelper.getCookie("showVulnerabilityDetails");
            ClientRecordAction.getCustomerVulnerabilityDetails(entityId, (val) => {
                if (
                    val &&
                    val.length > 0 &&
                    val.some(
                        (ele) =>
                            JsonDateParser.toDate(ele.StartDate) <= new Date() &&
                            (CommonHelper.isNullOrEmpty(ele.EndDate) ||
                                JsonDateParser.toDate(ele.EndDate) >= new Date())
                    )
                ) {
                    this.setState({
                        showVulnerabilityPopUp:
                            CommonHelper.isNullOrEmpty(settings) || !JSON.parse(settings)?.[entityId] ? true : false,
                        vulnerabilityDetail: val,
                    });
                } else {
                    this.closeVulnerabilityDetailPop();
                }
            });
            PermissionAction.checkUserHavePermissionForAdviserByActor(Number(entityId), (data) => {
                this.setState({ hasReadWriteAccessToAdviser: data?.IsReadOnly != true });
            });
            if (checkPermission(UserClaim.AdviserPortalCustomerFullyAccessCanView)) {
                ClientRecordAction.getCustomerNoteDetails(entityId, (val) => {
                    const regNote = val.filter(
                        (x) => x.NoteType == NoteType.RegulatoryCheck || x.NoteType == NoteType.RegulatoryCritical
                    );
                    this.setState({
                        importantNotes: regNote,
                    });
                });
            }
        } else {
            //consolidate account
            Action.getConsolidatedAccount(
                ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                (clientaccount: ClientAccount) => {
                    this.setState({
                        customerType: CustomerType.NotSpecified,
                        name: clientaccount?.AccountName,
                        accountId: clientaccount?.HeadClAccountId,
                        isConsolidatedAccount: true,
                    });
                }
            );
            PermissionAction.checkUserHavePermissionForAdviserByAccount(
                ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                (data) => {
                    this.setState({ hasReadWriteAccessToAdviser: data?.IsReadOnly != true });
                }
            );
        }
        this.setState({ isPresentationClicked: Array(Object.keys(portfolioDashboardTabEnum).length).fill(false) });
    }

    public componentWillUnmount() {
        const { setPageConfig } = this.context;
        setPageConfig(null);
        PortfolioDashboardAction.resetMultiSelection();
    }

    componentWillReceiveProps() {
        const tab = this.getTabIndex(false);
        if (tab != this.state.tabIndex && tab != portfolioDashboardTabEnum.Performance) {
            this.setState({ tabIndex: tab });
        }
    }

    private setupCoachmarks(tabIndex) {
        const { setPageConfig, reset } = this.context;
        switch (tabIndex) {
            case portfolioDashboardTabEnum.Summary:
                //setPageConfig(getSummaryCoachmarkerConfig(this.state.userInfo?.IsAppStoreEnabledForUser));
                //reset();
                break;
            case portfolioDashboardTabEnum.Investments:
                //setPageConfig(investmentCoachmarkerConfig);
                // reset();
                break;
            case portfolioDashboardTabEnum.Performance:
                //setPageConfig(performanceCoachmarkerConfig);
                // reset();
                break;
            case portfolioDashboardTabEnum.Roles:
                //setPageConfig(rolesCoachmarkerConfig);
                // reset();
                break;
            default:
                setPageConfig(null);
                break;
        }
    }

    onPresentationStatusChange(tabIndex, isPresentationClickedPre): void {
        const index = Object.keys(portfolioDashboardTabEnum).indexOf(portfolioDashboardTabEnum[tabIndex]);
        this.setState({
            isPresentationClicked: isPresentationClickedPre.map((item, key) =>
                key === index ? !isPresentationClickedPre[key] : item
            ),
        });
    }

    private onRestrictionReasonStoreChange(): void {
        const data = RestrictionReasonStore.getData();
        this.setState({ restrictionReasons: data });
    }

    onClientRecordStoreChange(): void {
        const data = ClientRecordStore.getData();
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.PersonalDetail])) {
            this.setState({
                customerType: CustomerType.Individual,
                name: `${TitleMap.getString(data[ClientRecordTab.PersonalDetail]?.Title)} ${
                    data[ClientRecordTab.PersonalDetail]?.GivenName
                } ${data[ClientRecordTab.PersonalDetail]?.FamilyName}`,
            });
        }
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.OrganisationDetails])) {
            const organisation: Organisation = data[ClientRecordTab.OrganisationDetails];
            if (organisation?.CustomerType && organisation?.CustomerType !== CustomerType.Company) {
                this.setState({
                    customerType: organisation.CustomerType,
                    name: data[ClientRecordTab.OrganisationDetails]?.Name,
                });
            } else {
                if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.CompanyDetails])) {
                    this.setState({
                        customerType: CustomerType.Company,
                        name: data[ClientRecordTab.CompanyDetails]?.CompanyName,
                    });
                }
            }
        }
    }

    private getTabIndex(
        update: boolean
    ): portfolioDashboardTabEnum | dashboardRelatedPageEnum | prospectDashboardTabEnum {
        const i = window.location.pathname.lastIndexOf("/");
        const path = window.location.pathname.substr(i + 1);
        if (CommonHelper.isNullOrEmpty(path)) {
            return this.state.isProspect
                ? prospectDashboardTabEnum.Activity
                : isTradingAccount(PortfolioDashboardStore.getData())
                ? portfolioDashboardTabEnum.Documents
                : portfolioDashboardTabEnum.Summary;
        }

        let tabIndex: portfolioDashboardTabEnum | dashboardRelatedPageEnum | prospectDashboardTabEnum = this.state
            .isProspect
            ? portfolioDashboardTabEnum.Summary
            : prospectDashboardTabEnum.Activity;
        const tabs = this.state.isProspect
            ? prospectDashboardTabEnum
            : this.state.isConsolidatedAccount
            ? consolidatedAccountDashboardTabEnum
            : portfolioDashboardTabEnum;
        getEnumValues(tabs).forEach((element: string) => {
            if (element.toLowerCase() === path.toLowerCase()) {
                tabIndex = element as portfolioDashboardTabEnum;
            }
        });
        if (dashboardRelatedPageEnum.ProductOverview.toLowerCase() === path.toLowerCase()) {
            tabIndex = dashboardRelatedPageEnum.ProductOverview;
        }
        if (dashboardRelatedPageEnum.ClientReport.toLowerCase() === path.toLowerCase()) {
            tabIndex = dashboardRelatedPageEnum.ClientReport;
        }
        if (update) {
            this.setupCoachmarks(tabIndex);
        }
        return tabIndex;
    }

    private onTabClick(tab) {
        if (tab === dashboardRelatedPageEnum.ClientReport || tab === dashboardRelatedPageEnum.ProductOverview) {
            return;
        }

        this.setupCoachmarks(tab);
        Navigator.navigateTo(
            Urls.get().main.PortfolioDashboard({
                hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
            })[tab.toString().toLowerCase()]
        );
        this.setState({ tabIndex: tab });
    }

    private getMultiSelection() {
        const customerId = this.getCusomterEntityId().entityId;
        const customerHierarchyId = this.getCusomterHierarchyId();
        if (isConsolidate()) {
            PortfolioDashboardAction.getAllAccountsByConsolidateAccountId(customerId, (accounts) => {
                PortfolioDashboardAction.getMultiSelection(customerHierarchyId, accounts, (selections) => {
                    this.setState(
                        {
                            isProspect: false,
                        },
                        () => {
                            const tabIndex = this.getTabIndex(true);
                            this.setState({ isLoading: false, tabIndex });
                        }
                    );
                });
            });
        } else {
            PortfolioDashboardAction.getAllAccountsByCustomerId(customerId, (accounts) => {
                const _accounts = (accounts || []).filter((acc) => acc.AccountStatus != AccountStatus.InProgress);
                PortfolioDashboardAction.getMultiSelection(customerHierarchyId, _accounts, (selections) => {
                    this.setState(
                        {
                            isProspect: (_accounts || []).length == 0,
                        },
                        () => {
                            const tabIndex = this.getTabIndex(true);
                            this.setState({ isLoading: false, tabIndex });
                        }
                    );
                });
            });
        }
    }

    private getCusomterEntityId() {
        const customerId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        return HierarchyIdHelper.generateHierarchyId(customerId);
    }
    private getCusomterHierarchyId() {
        return ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
    }

    public getContent(
        tabIndex:
            | portfolioDashboardTabEnum
            | dashboardRelatedPageEnum
            | prospectDashboardTabEnum
            | consolidatedAccountDashboardTabEnum
    ) {
        let _content = null;
        const customerid = this.getCusomterEntityId().entityId;
        switch (tabIndex) {
            case portfolioDashboardTabEnum.Summary:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalPerformanceSummaryCanView}>
                        <PortfolioDashboardSummary
                            customerid={customerid}
                            hasReadWriteAccessToAdviser={this.state.hasReadWriteAccessToAdviser}
                            ProductOverviewNavigate={() => {}}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                            restrictionReasons={this.state?.restrictionReasons}
                        />
                    </Permission>
                );
                break;
            case portfolioDashboardTabEnum.Investments:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalClientInvestmentsCanView}>
                        <PortfolioDashboardInvestment
                            customerid={customerid}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                        />
                    </Permission>
                );
                break;
            case portfolioDashboardTabEnum.Performance:
                _content = (
                    <Permission
                        userClaim={[
                            UserClaim.AdviserPortalPerformanceSummaryCanView,
                            UserClaim.AdviserPortalPerformanceDetailCanView,
                            UserClaim.AdviserPortalRealisedGainLossCanView,
                            UserClaim.AdviserPortalUnrealisedGainLossCanView,
                            UserClaim.AdviserPortalPerformanceIncomeCanView,
                            UserClaim.AdviserPortalPerformanceChargesCanView,
                        ]}
                    >
                        <PortfolioDashboardPerformance
                            customerid={customerid}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                        />
                    </Permission>
                );
                break;
            case portfolioDashboardTabEnum.Insights:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalPerformanceSummaryCanView}>
                        <PortfolioDashboardInsights
                            customerid={customerid}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                        />
                    </Permission>
                );
                break;
            case portfolioDashboardTabEnum.Transactions:
                _content = (
                    <Permission
                        userClaim={[
                            UserClaim.AdviserPortalInvestmentTransactionCanView,
                            UserClaim.AdviserPortalPaymentsAndWithdrawlsCanView,
                            UserClaim.AdviserPortalAccountTransfersCanView,
                            UserClaim.AdviserPortalDividendSummaryCanView,
                            UserClaim.AdviserPortalOtherCorporateActionsCanView,
                            UserClaim.AdviserPortalPerformanceChargesCanView,
                        ]}
                    >
                        <PortfolioDashboardTransactions
                            customerid={customerid}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                        />
                    </Permission>
                );
                break;
            case portfolioDashboardTabEnum.Documents:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalDocumentLibraryCanView}>
                        <PortfolioDashboardDocuments
                            customerid={customerid}
                            isProspect={this.state.isProspect}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                        />
                    </Permission>
                );
                break;
            case portfolioDashboardTabEnum.Roles:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                        <PortfolioDashboardRoles
                            customerid={customerid}
                            hasReadWriteAccessToAdviser={this.state.hasReadWriteAccessToAdviser}
                            customerType={this.state.customerType}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                        />
                    </Permission>
                );
                break;
            case portfolioDashboardTabEnum.Activity:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalCustomerPartialAccessCanView}>
                        <PortfolioDashboardActivity
                            customerid={customerid}
                            isProspect={this.state.isProspect}
                            customerType={this.state.customerType}
                            hasReadWriteAccessToAdviser={this.state.hasReadWriteAccessToAdviser}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                        />
                    </Permission>
                );
                break;
            case portfolioDashboardTabEnum.ESG:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalEsgAnalyserCanView}>
                        <EsgAnalyser
                            customerid={customerid}
                            isBtnPresentationClicked={this.state.isPresentationClicked}
                            onPresentationViewStatusChange={this.onPresentationStatusChange}
                        />
                    </Permission>
                );
                break;
            case dashboardRelatedPageEnum.ProductOverview:
                _content = (
                    <ProductOverview
                        customerid={customerid}
                        isBtnPresentationClicked={this.state.isPresentationClicked}
                        onPresentationViewStatusChange={this.onPresentationStatusChange}
                    />
                );
                break;
            case dashboardRelatedPageEnum.ClientReport:
                _content = <ClientReport customerid={customerid} />;
                break;
        }

        return _content;
    }

    private closeVulnerabilityDetailPop() {
        const curSettings = CookieHelper.getCookie("showVulnerabilityDetails");
        const settings = CommonHelper.isNullOrEmpty(curSettings) ? {} : JSON.parse(curSettings);
        const { entityId } = this.getCusomterEntityId();
        settings[entityId] = true;
        CookieHelper.setCookie("showVulnerabilityDetails", JSON.stringify(settings), 0, "/");
        this.setState({ showVulnerabilityPopUp: false });
    }

    public render(): JSX.Element {
        const { tabIndex, isLoading, isProspect, name, isConsolidatedAccount, restrictionReasons } = this.state;
        if (isLoading || this.state.customerType == null) {
            return null;
        }

        let tabs = null;
        if (
            tabIndex !== dashboardRelatedPageEnum.ClientReport &&
            tabIndex !== dashboardRelatedPageEnum.ProductOverview
        ) {
            if (isProspect) {
                tabs = prospectDashboardTabEnum;
            } else if (isConsolidatedAccount) {
                tabs = consolidatedAccountDashboardTabEnum;
            } else {
                tabs = portfolioDashboardTabEnum;
            }
        }
        return (
            <>
                <div role={this.state.isPresentationView ? "" : "main"} id="main">
                    <PresentationViewWrapper
                        setParentState={this.setState}
                        header={
                            <>
                                <PortfolioDashboardHeader
                                    name={name}
                                    customerid={this.getCusomterEntityId().entityId}
                                    isConsolidate={isConsolidatedAccount}
                                    id={
                                        isConsolidate()
                                            ? this.state.accountId
                                            : this.getCusomterEntityId().entityId.toString()
                                    }
                                    portfolioDashboardTabEnum={tabIndex as portfolioDashboardTabEnum}
                                    restrictionReasons={restrictionReasons}
                                    vulnerabilityDetail={this.state.vulnerabilityDetail}
                                    isAdviser={this.state.userInfo?.IsAdviser || false}
                                    isAdmin={this.state.userInfo?.IsAdmin || false}
                                    isInternalUser={this.state.userInfo?.IsInternalUser || false}
                                    importantNotes={this.state.importantNotes}
                                />
                            </>
                        }
                        tabs={tabs}
                        tabIndex={tabIndex}
                        onTabClick={(tab) => this.onTabClick(tab)}
                    >
                        {this.getContent(tabIndex)}
                    </PresentationViewWrapper>
                    {this.state.showVulnerabilityPopUp &&
                        this.state.userInfo?.IsAdmin &&
                        checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView) && (
                            <Lightbox
                                show={this.state.showVulnerabilityPopUp}
                                title={"Vulnerable customer warning present"}
                                onClose={() => this.closeVulnerabilityDetailPop()}
                                type={LightboxType.Modal}
                                cssWrapper="is-default-lightbox"
                            >
                                {this.state.vulnerabilityDetail.some(
                                    (ele) =>
                                        !CommonHelper.isNullOrEmpty(ele.ReviewDate) &&
                                        CommonHelper.isNullOrEmpty(ele.EndDate) &&
                                        JsonDateParser.toDate(ele.ReviewDate) < new Date()
                                ) && <p>Vulnerability needs revalidated. Please review with customer.</p>}
                                <p>
                                    <a
                                        className="hyperlink"
                                        onClick={() => {
                                            this.closeVulnerabilityDetailPop();
                                            Navigator.navigateTo(
                                                Urls.get().main.PortfolioDashboard({
                                                    hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                        ContextType.Customer
                                                    ),
                                                }).ContactDetail
                                            );
                                        }}
                                    >
                                        {"View details >"}
                                    </a>
                                </p>
                                <button className="btn primary" onClick={() => this.closeVulnerabilityDetailPop()}>
                                    Ok
                                </button>
                            </Lightbox>
                        )}
                </div>
            </>
        );
    }
}
PortfolioDashboard.contextType = CoachMarkerContext;
